<template lang="pug">
v-col.pa-0(v-if='Herramientas').mt-12
    v-container(fluid   ).pa-0.mt-12
        .header.pa-0.pt-10
            
            v-row.align-center.text-center.d-md-none
                v-col(cols=12 ).mt-3
                    h1.font-weight-bold( style=' color:var(--primary)' ) {{Herramientas.tituloResaltado}}
                    h2.font-weight-bold( style=' line-height : 5px; font-size: 25px; color:var(--secondary)' ).mt-1 {{Herramientas.titulo}}
                    div.d-flex.flex-column.align-center.mt-6
                        .lineamorada( style='width:85px' )
                    p( style='line-height : 5px; font-size: 15px' v-html='Herramientas.subtitulo' ).mt-4     
            .titulo.mt-12.d-none.d-md-flex 
                v-col(cols=6 md=8).align-center.text-center
                    v-row.justify-center.align-center
                        h1.textoResaltado.font-weight-bold( style='font-size: 45px; font-weight: 900; color:var(--primary)' ) {{Herramientas.tituloResaltado}}
                    v-row.justify-start
                        h2.textoSecundario.font-weight-bold(style='font-size: 35px; color:var(--secondary)' ).mt-3 {{Herramientas.titulo}}
                            div.d-flex.flex-column.align-end
                                .lineamorada( style='width:85px')
                v-col(cols=12 md=6).mt-4
                    v-row.ml-0
                        p.texto(  style='line-height : 5px; font-size: 15px; color:var(--secondary)' v-html='Herramientas.subtitulo' )

            .ruleta(ref='ruleta' 
                    @mouseleave='cursor=0'
                    @mousedown='marcarClick'  
                    @mouseup='marcarClick' 
                    @touchstart='marcarTouch' 
                    @touchend='marcarTouch')
                
                .ruleta-image(color='transparent' :key='imagen'  v-for='{imagen, imagenbaja},i of Herramientas.contenido' :style="`transform: rotate( ${i * 19.9 + rotacion}deg)`").d-md-none
                    v-row.justify-center.align-center
                        v-col(cols=12)
                            v-img( :src=' imagen '  height='460px' width='250px')
                    v-row.justify-center.align-center
                        v-col(cols=12)
                            v-img( :src=' imagenbaja ' max-height="250" max-width="290" contain)
                
                .ruleta-image(color='transparent' :key='imagen'  v-for='{imagen, imagenbaja},i of Herramientas.contenido' :style="`transform: rotate( ${i * 20 + rotacion}deg)`").d-none.d-md-block
                    v-img( :src=' imagen '  height='500px' width='250px')
                    v-row.justify-center.align-center
                        v-img( :src=' imagenbaja ' max-height="200" max-width="280" contain)
            
                v-row.justify-center.align-center.flechitas
                    v-btn.mr-12(  style=' color:var(--secondary)' @click='adelante()' outlined icon) 
                        v-icon mdi-arrow-left 
                    v-btn.ml-12( style=' color:var(--secondary)' @click='atras()' icon outlined)
                        v-icon mdi-arrow-right 
    //-MOVIL
    //-v-container(fluid).d-md-none.pa-0.colormovil
        .headerMOVIL.pa-0 
            //-CONTENIDO
            v-row.align-center.text-center
                v-col(cols=12 ).mt-3
                    h1.font-weight-bold( style=' color:var(--primary)' ) {{Herramientas.tituloResaltado}}
                    h2.font-weight-bold( style=' line-height : 5px; font-size: 25px; color:var(--secondary)' ).mt-1 {{Herramientas.titulo}}
                    div.d-flex.flex-column.align-center.mt-6
                        .lineamorada( style='width:85px' )
                    p( style='line-height : 5px; font-size: 15px' v-html='Herramientas.subtitulo' ).mt-4      
                    //-CORRUSEL
                v-carousel(cycle v-model='step' :hide-delimiter-background='true' :show-arrows="false"  ).mb-12
                    v-carousel-item( style='position: relative' color='transparent' :key='imagen'  v-for='{imagen, imagenbaja},i of Herramientas.ContenidoMovil' )
                        v-img( :src=' imagen ' max-height='340' max-width='400' contain )
                        v-col(align='center' justify='center')
                            v-img( :src=' imagenbaja ' max-height="150" max-width="200" contain)
                    //-botones
                    v-row.justify-center.align-center.flechitaMOVIL
                        v-btn.mr-12(  style=' color:var(--secondary)' @click='step--'  outlined icon).flechaIZ
                            v-icon mdi-arrow-left 
                        v-btn.ml-12( style=' color:var(--secondary)' @click='step++' icon outlined).flechaDere
                            v-icon mdi-arrow-right
                            

                
                        
                    
            
               
                
</template>
<style lang="sass" scoped>
.flechitaMOVIL
    position: relative
    top: -60%
    .flechaDere
        position: relative
        left: 14%
    .flechaIZ
        position: relative
        right: 14%
        
.flechitas
    position: relative
    top:90%
.colormovil
    background-color: #f2f2f2
    
.headerMOVIL
    height: 100vh
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    background-size: cover
    .titulo 
        height: 20vh
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        background-size: cover  
.ruleta
    position: relative
    width: 100%
    height: 2000px
    overflow: hidden
    .ruleta-image
        transform-origin: 50% 800%
        transition: transform 1s
        position: absolute
        top: 0
        left: 0
        right: 0
        margin: auto
        width: 250px
        height: 200px
.texto
    position: relative
    top:100px
    left: 5vh
.SUB
    color: var(--secondary)
    left: 0vh

.lineamorada
    height: 4px
    background-color: #270640 !important   

.textoResaltado
    position: relative
    top: 80px
    color: var(--primary)
    left: 6vh
.textoSecundario
    position: relative
    left: 10vh
    top: 50px
    color: var(--secondary)
.header
    height: 1000px
    background-color: #f2f2f2
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    background-size: cover
    .titulo 
        height: 20vh
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        background-size: cover   

</style>
<script>
export default {
    data () {
      return {
        cursor: 0,
        rastrear: false,
        rotacion: 300,
        interval: null,
        seleccionado: 0,
        galeria:[],
        step: 0,
      }
    },
    watch:{
        'Herramientas.contenido'(){
            const fuente = this.Herramientas.contenido
            if(this.$refs.ruleta){
            this.$refs.ruleta.$el.style.transform = `rotate( ${this.Herramientas.contenido.length / 2 * 20 }deg)`
            }   
        },
        'cursor':{
            handler(despues, antes){
                if(antes == 0 || despues == 0) return
                else{
                    console.log(despues - antes < 0)
                    if(despues - antes < 0) this.atras() 
                    else this.adelante() 
                    this.cursor = 0

                }
                
            }
        }
        
    },
    created(){
        if(this.$refs.ruleta){
            this.$refs.ruleta.$el.style.transform = `rotate( ${this.Herramientas.contenido.length / 2 * 20 }deg)`
        } 
    },
    methods: {
        marcarClick(event){
           this.cursor = event.clientX
        },
        marcarTouch(event){
            this.cursor = event.changedTouches[0].clientX
        },
        adelante(){
            if(this.rotacion < 0 ) this.rotacion += 19.795
            else this.rotacion = 0
            
        },
        atras(){
            if(this.rotacion > (this.Herramientas.contenido.length-1) * -19.795) this.rotacion -= 19.795
            
        },
    },

}
</script>